import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../../lib';


const formName = 'Sandwich Boards'; 

const defaultValues = {
  'Quantity': '',
  'Content': '',
  'Type': '',
};

const fields = [
  'Quantity',
  'Content',
  'Type',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <Textarea
        textareaId='Content'
        textareaName='Content'
        register={register}
        formState={formState}
        label='Content'
        theme={textareaTheme}
      />

      <Radio
        radioId='Type'
        radioName='Type'
        legend='Type?'
        options={[
          { value: 'standard 10mm Intecel, 23.5 x 31.5', label: 'Standard, 10mm Intecel - 23.5" x 31.5" (bylaw size)' },
          { value: 'custom size, standard 10mm Intecel', label: 'Custom size, 10mm Intecel' },
          { value: 'metal, 24 x 36', label: 'Metal A-frame, 24" x 36"' },
          { value: 'metal, inserts only', label: 'Metal A-frame, inserts only' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
